<template>
	<div class="statebar">
		<div class="statebar-line con-750">
			<div class="statebar-current" :style="`width: ${stateBarWidth}%`"></div>
		</div>
		<div class="statebar-name-position">
			<div class="statebar-name">
				<div v-for="(step, index) in computedSteps" :key="index">{{ step }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters(['hasMovables', 'getCurrentStep']),
		computedSteps() {
			return this.hasMovables
				? [
						'Biztosítás tárgya',
						'Ingatlan adatai',
						'Ingóság adatai',
						'Szerződés adatai',
						'Tájékoztató',
						'Összehasonlítás',
				  ]
				: ['Biztosítás tárgya', 'Ingatlan adatai', 'Szerződés adatai', 'Tájékoztató', 'Összehasonlítás'];
		},
		computedStepsByRouteName() {
			return this.hasMovables ? {
					'home': 0,
					'property-details': 1,
					'movable': 2,
					'contract-details': 3,
					'package-information': 4,
					'comparison': 5,
				} : {
					'home': 0,
					'property-details': 1,
					'contract-details': 2,
					'package-information': 3,
					'comparison': 4,
				};
		},
		stateBarWidth() {
			return this.computedStepsByRouteName[this.$route.name] * (this.hasMovables ? 20 : 25);
		},
	},
};
</script>
